import { KeyboardEvent } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';

interface LookupSearchBarProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  loading: boolean;
  onSearch: () => void;
  onClearFilters: () => void;
  onExportCsv: () => void;
}

const LookupSearchBar = ({
  searchTerm,
  setSearchTerm,
  loading,
  onSearch,
  onClearFilters,
  onExportCsv
}: LookupSearchBarProps) => {
  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <div className="search-section mb-3">
      <h5 style={{ fontSize: '1.1rem', fontWeight: 500, marginBottom: '15px' }}>
        Search Products and Campaigns
      </h5>
      <div className="d-flex gap-3 align-items-center mb-3" style={{ flexWrap: 'wrap' }}>
        <Form.Control
          type="text"
          placeholder="Search Products and Campaigns"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyPress={handleKeyPress}
          size="sm"
          style={{maxWidth: '300px', marginRight: '8px'}}
        />
        <Button
          variant="primary"
          onClick={onSearch}
          disabled={loading}
          size="sm"
          style={{ fontSize: 12, minWidth: '100px', marginRight: '8px' }}
        >
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
                style={{ width: '0.7rem', height: '0.7rem' }}
              />
              Searching...
            </>
          ) : (
            'Search'
          )}
        </Button>
        <Button
          variant="secondary"
          onClick={onClearFilters}
          size="sm"
          style={{ fontSize: 12, marginRight: '8px' }}
        >
          Reset filters
        </Button>
        
        <Button
          variant="secondary"
          onClick={onExportCsv}
          size="sm"
          style={{ fontSize: 12 }}
        >
          Export CSV
        </Button>
      </div>
    </div>
  );
};

export default LookupSearchBar;